<template>
  <div class="">
    <span id="formPayment" class="anchor"></span>
    <!-- form card cc payment -->
    <div class="card card-outline-secondary">
      <div class="card-body">
        <form
          id="marginDetailsform"
          class="form"
          role="form"
          autocomplete="off"
          @submit.prevent="submitmarginDetailsform"
        >
          <label class="form-group-label label-font" for="flexRadioDefault1">
            Select Margin Type
          </label>
          <div class="form-group">
            <input
              id="flexRadioDefault1"
              v-model="amountDetails.paymentType"
              class="form-group-input"
              type="radio"
              name="flexRadioDefault"
              value="Percentage"
            />
            <label class="form-group-label label-font2" for="flexRadioDefault1">
              Percentage
            </label>

            <input
              id="flexRadioDefault2"
              v-model="amountDetails.paymentType"
              style="margin-left: 30px;"
              class="form-group-input"
              type="radio"
              name="flexRadioDefault"
              value="Fixed"
            />
            <label class="form-group-label label-font2" for="flexRadioDefault2">
              Fixed cost
            </label>

            <input
              id="flexRadioDefault3"
              v-model="amountDetails.paymentType"
              style="margin-left: 30px;"
              class="form-group-input"
              type="radio"
              name="flexRadioDefault"
              value="Both"
            />
            <label class="form-group-label label-font2" for="flexRadioDefault3">
              Both
            </label>
          </div>

          <!-- <div class="form-group">
            <label class="form-group-label label-font2">Enter Amount</label>
          </div> -->
          <div
            v-if="
              amountDetails.paymentType === 'Percentage' ||
                amountDetails.paymentType === 'Both'
            "
            class="form-group"
            style="max-width: 233px;"
          >
            <span class="input input--hoshi">
              <input
                id="input-4"
                v-model="amountDetails.percentage"
                class="input__field input__field--hoshi"
                type="number"
                min="0"
                autocomplete="off"
                required
                @keyup="checkValue"
              />
              <label
                class="input__label input__label--hoshi input__label--hoshi-color-1"
                for="input-4"
              >
                <span
                  class="input__label-content input__label-content--hoshi"
                  :class="
                    amountDetails.percentage != null ? 'active_input' : null
                  "
                  >Enter Percentage (%)<span class="color-red">*</span></span
                >
              </label>
            </span>
          </div>
          <div
            v-if="
              amountDetails.paymentType === 'Fixed' ||
                amountDetails.paymentType === 'Both'
            "
            class="form-group"
            style="max-width: 233px;"
          >
            <span class="input input--hoshi">
              <input
                id="input-4"
                v-model="amountDetails.amount"
                class="input__field input__field--hoshi"
                type="text"
                maxlength="10"
                autocomplete="off"
                required
                @keyup="valueValidation"
              />
              <label
                class="input__label input__label--hoshi input__label--hoshi-color-1"
                for="input-4"
              >
                <span
                  class="input__label-content input__label-content--hoshi"
                  :class="
                    amountDetails.amount || amountDetails.amount == 0
                      ? 'active_input'
                      : null
                  "
                  >Enter Cost ($)<span class="color-red">*</span></span
                >
              </label>
            </span>
          </div>

          <span
            v-if="
              errorFlag &&
                (amountDetails.paymentType === 'Percentage' ||
                  amountDetails.paymentType === 'Both')
            "
            class="color-red"
            >The maximum percentage cannot be more than 20%</span
          >
          <div class="form-group">
            <input
              id="inlineCheckbox1"
              v-model="amountDetails.OverrideFlag"
              class="form-group-input"
              type="checkbox"
            />
            <label class="form-group-label label-font2" for="inlineCheckbox1"
              >Override all settings</label
            >
            <br />
            <span class="text-muted"
              >Note: Do you want to override margin setting for all Vendor and
              Service forms ?</span
            >
          </div>
          <hr />
          <div class="form-group row">
            <div class="col-md-3">
              <button
                type="submit"
                class="btn s-red-btn mr-b30"
                :disabled="!amountDetails.OverrideFlag"
                >Save</button
              >
            </div>
          </div>
        </form>
      </div>
    </div>
    <!-- /form card cc payment -->
    <loader v-if="loading"></loader>
    <popup
      v-if="marginUpdatedFlag"
      :msg="postMessage"
      @response="marginUpdatedFlag = false"
    ></popup>
  </div>
</template>
<script>
import popup from '@views/popup'
import { required, minLength } from 'vuelidate/lib/validators'
import loader from '@views/loader'
import { superAdminMethods } from '@state/helpers'

export default {
  components: {
    loader,
    popup,
  },
  data() {
    return {
      amountDetails: {
        paymentType: 'Percentage',
      },
      loading: false,
      errorFlag: false,
      postMessage: '',
      marginUpdatedFlag: false,
    }
  },
  validations: {
    amountDetails: {
      amount: {
        required,
        minLength: minLength(6),
      },
    },
  },
  methods: {
    ...superAdminMethods,

    // save all margin Settings Data
    async submitmarginDetailsform() {
      try {
        this.loading = true

        let requestBody = {
          MarginType: this.amountDetails.paymentType,
          FixedMargin: Number(this.amountDetails.amount)
            ? Number(this.amountDetails.amount)
            : 0,
          PercentMargin: Number(this.amountDetails.percentage)
            ? Number(this.amountDetails.percentage)
            : 0,
          IsOverrideChild: this.amountDetails.OverrideFlag,
        }

        await this.adminMarginSettings(requestBody)
        this.amountDetails = {
          paymentType: 'Percentage',
        }
        this.loading = false
        this.postMessage = 'To all services, a margin was assigned.'

        this.marginUpdatedFlag = true
      } catch (error) {
        this.loading = false
        this.postMessage = 'Something went wrong please try again !'

        this.marginUpdatedFlag = true
      }
    },
    // Validation Only number
    NumbersOnly(evt) {
      evt = evt || window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    checkValue() {
      console.log('percent :', this.amountDetails.percentage)
      let enteredAmount = Number(this.amountDetails.percentage)
        ? Number(this.amountDetails.percentage)
        : 0
      if (
        this.amountDetails.paymentType === 'Percentage' ||
        this.amountDetails.paymentType === 'Both'
      ) {
        if (enteredAmount > 20) {
          this.errorFlag = true
          setTimeout(() => {
            this.errorFlag = false
          }, 4000)
        }

        this.amountDetails.percentage = Number(this.amountDetails.percentage)
          ? Number(this.amountDetails.percentage) > 20
            ? 20
            : Number(this.amountDetails.percentage) < 0
            ? 0
            : Number(this.amountDetails.percentage)
          : 0
      }
    },
    valueValidation() {
      this.amountDetails.amount = Number(this.amountDetails.amount)
        ? Number(this.amountDetails.amount) < 0
          ? 0
          : Number(this.amountDetails.amount)
        : 0
    },
  },
}
</script>
<style scoped>
.label-font {
  font-family: 'JosefinSans-Bold';
  padding: 5px;
}
.label-font2 {
  font-family: 'JosefinSans-SemiBold';
  padding: 5px;
}
.color-red {
  color: red;
  font-size: smaller;
}
</style>
